import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'

const styles = () => ({
  message: {
    color: '#777777',
    marginTop: 16,
    fontSize: 14
  }
})

const Message = ({ classes, isB2C }) => {
  return isB2C && (
    <div className={classes.message}>
      *Revisar condiciones en consultoría vigente del ciclo.
    </div>
  )
}

export const DisclaimerOnlineMessage = withStyles(styles)(Message)
